import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import './my-preferences.form.scss';
import { UserAccountDto } from '../../../services/dtos/user-account.dto';
import { NotificationPreferenceDto } from '../../../services/dtos/notification-preference.dto';

/**
 * Render le formulaire pour les préférences utilisateur.
 *
 * @param {object} props - Propriétés.
 * @param {UserAccountDto} props.user - Les informations de l'utilisateur.
 * @param {boolean} props.disabled - Spécifie si le formulaire est désactivé.
 * @param {function} props.handlerChangePrefs - La fonction qui s'exécute si une préférence est changée.
 * @param {NotificationPreferenceDto} props.handlerChangePrefs.notif - La préférence changée.
 * @param {boolean} props.handlerChangePrefs.chekecd - La nouvelle valeur de la préférence.
 * @return {JSX.Element} Le formulaire.
 */
export default function MyPreferencesForm(
    props: Readonly<{
        user: UserAccountDto;
        disabled: boolean;
        handlerChangePrefs: (notif: NotificationPreferenceDto, chekecd: boolean) => void;
    }>
): JSX.Element {
    return (
        <div className={'preferenceForm'}>
            <Typography variant="body2" className="preferenceForm__description">
                Je souhaite recevoir un e-mail à chaque ajout ou modification concernant :
            </Typography>
            <Grid container spacing={2} className="preferenceForm__list">
                {/* On boucle sur chaque item pour créer la page */}
                {props.user.notificationPreferences?.map(pref => {
                    return (
                        <Grid item xs={12} key={pref.mandateId + '-' + pref.userId}>
                            <div className="preferenceForm__item">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={Boolean(pref.checked)}
                                            onChange={(_event, checked) => props.handlerChangePrefs(pref, checked)}
                                            disabled={props.disabled}
                                        />
                                    }
                                    label={pref.label}
                                />
                            </div>
                        </Grid>
                    );
                })}
            </Grid>
        </div>
    );
}
